import React from "react";
import "./FindUsSection.css";

function FindUsSection() {
  const whatsappNumber = "447802484141";
  const facebookUrl = "https://www.facebook.com/profile.php?id=61561727786448";

  return (
    <section className="find-us-section" id="contact">
      <div className="find-us-container">

        {/* Title */}
        <h2 className="find-us-title">
          Find us in <span>Milton Keynes</span>
        </h2>

        {/* Content Layout */}
        <div className="find-us-grid">

          {/* Left Info Card */}
          <div className="info-card">

            <h3 className="clinic-title">
              Rejuvenate Aesthetics & Skincare Clinic MK
            </h3>

            {/* Address */}
            <div className="info-row">
              <div className="icon">
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
              </div>

              <div className="info-text">
                <p>26 Victoria Drive, Glebe Farm</p>
                <p>Milton Keynes</p>
                <p>MK17 8XU</p>
              </div>
            </div>

            {/* Phone */}
            <div className="info-row">
              <div className="icon">
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>

              <div className="info-text">
                <a
                  href="tel:07802484141"
                  className="link-text"
                >
                  07802 484141
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="info-row">
              <div className="icon">
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>

              <div className="info-text">
                <a
                  href="mailto:hello@your-clinic-domain.co.uk"
                  className="link-text"
                >
                  Contact@rejuvenateaesthesticsandskincareclinic.co.uk
                </a>
              </div>
            </div>

            {/* Hours */}
            <div className="info-row hours-row">
              <div className="icon">
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </div>

              <div className="hours-list">
                <div className="hours-item">
                  <span>Monday – Friday</span>
                  <span className="status">To be confirmed</span>
                </div>

                <div className="hours-item">
                  <span>Saturday</span>
                  <span className="status">To be confirmed</span>
                </div>

                <div className="hours-item">
                  <span>Sunday</span>
                  <span className="status">To be confirmed</span>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="card-actions">

              {/* WhatsApp */}
              <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="currentColor"
                >
                  <path d="M12.031 2c-5.517 0-9.997 4.48-9.997 9.998 0 2.146.68 4.133 1.839 5.757L2 22l4.417-1.157a9.96 9.96 0 005.614 1.708c5.518 0 9.998-4.48 9.998-9.998A9.997 9.997 0 0012.031 2zm0 18.232c-1.802 0-3.504-.486-4.978-1.332l-.358-.207-2.628.688.7-2.562-.229-.365a8.214 8.214 0 01-1.282-4.456c0-4.555 3.706-8.261 8.261-8.261 4.556 0 8.262 3.706 8.262 8.261 0 4.556-3.706 8.262-8.262 8.262z" />
                </svg>
                CHAT ON WHATSAPP
              </a>

              {/* Instagram */}
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-social"
                aria-label="Instagram"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    ry="5"
                  />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line
                    x1="17.5"
                    y1="6.5"
                    x2="17.51"
                    y2="6.5"
                  />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-social"
                aria-label="Facebook"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="currentColor"
                >
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.891h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>

            </div>
          </div>

          {/* Right Map Card */}
          <div className="map-card">
            <iframe
              title="Rejuvenate Aesthetics & Skincare Clinic MK Location"
              src="https://www.google.com/maps?q=26+Victoria+Drive,+Glebe+Farm,+Milton+Keynes,+MK17+8XU&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

        </div>
      </div>
    </section>
  );
}

export default FindUsSection;